import { useCallback, useEffect, useState } from 'react'

import {
  actions as builderActions,
  WizardState
} from '../../../../tradebuilder-v2/modules/00-builder/state/builder-slice'
import { FundingSource } from '../../../../tradebuilder-v2/modules/02-terms/state/terms-slice'
import { useAppDispatch, useAppSelector } from '../../../../tradebuilder-v2/store/hooks'
import { useActions } from '../../../../tradebuilder-v2/store/use-actions'
import {
  actions as activateActions,
  postActivateApprove,
  postActivateApproveSwitch
} from '../state/trade-activate-slice'
import TradeActivateStateless from '../templates/trade-activate-stateless'

const TradeActivate = () => {
  const builderState = useAppSelector(state => state.builder)
  const termsState = useAppSelector(state => state.terms)
  const state = useAppSelector(state => state.tradeActivate)
  const actions = useActions(activateActions)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const dispatch = useAppDispatch()

  const initialise = useCallback(
    (builder: WizardState) => {
      setIsLoading(true)
      actions.reset()
      actions.initialise({
        userName: builder.userName,
        userType: builder.userType,
        userRoles: builder.userRoles,
        accountId: builder.accountId,
        approvalEvents: builder.approvalEvents,
        status: builder.status,
        isSwitch: termsState.terms.fundingSource === FundingSource.Switch
      })
    },
    [actions, termsState.terms.fundingSource]
  )

  useEffect(() => {
    initialise(builderState)
  }, [builderState, initialise])
  useEffect(() => {
    initialise(builderState)
  }, [
    builderState,
    builderState.accountId,
    builderState.approvalEvents,
    builderState.status,
    initialise
  ])

  useEffect(() => {
    if (state.accountId === builderState.selectedAccountId) {
      setIsLoading(false)
    }
  }, [builderState.selectedAccountId, state.accountId, state.approvalEvents])
  useEffect(() => {
    if (state.accountId === builderState.selectedAccountId && state.success === true) {
      dispatch(
        builderActions.refreshTradeStatus(state.accountId, {
          title: 'The trade has been successfully activated'
        })
      )
    }
  }, [
    builderState.selectedAccountId,
    builderState.status,
    dispatch,
    state.success,
    state.accountId
  ])

  const onTradeActivate = (comments: string) => {
    if (termsState.terms.fundingSource === FundingSource.Switch) {
      dispatch(postActivateApproveSwitch(state.accountId))
    } else {
      dispatch(postActivateApprove(state.accountId, comments))
    }
  }

  if (!isLoading) {
    return (
      <TradeActivateStateless
        state={state}
        status={builderState?.status}
        onTradeActivate={onTradeActivate}
      />
    )
  }

  return null
}

export default TradeActivate
